import logo from "./images/Logo_Yellow_Transparent_Horizontal.gif";
import "./App.css";
import * as React from "react";
import Grid from "@mui/material/Grid";

function App() {
  return (
    <div className="App">
      <Grid
        container
        spacing={0}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item>
          <img src={logo} className="App-logo" alt="logo" />
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
